import PropTypes from 'prop-types'
import React, { Component } from 'react'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'
import ListProducersByRegion from './ListProducersByRegion'

const query = gql`
  query GetProducersOfCategory($category: String!) {
    getProducersOfCategory(category: $category) {
      regionsWithProducers {
        region {
          id
          name
        }
        producers {
          id
          companyName
          presentation
          photoProducerUrl
        }
      }
      error
    }
  }
`

class ListProducersByRegionContainer extends Component {
  render() {
    const { category } = this.props

    return (
      <Query query={query} variables={{ category }}>
        {({ loading, data }) => (
          <ListProducersByRegion
            loading={loading}
            data={data ? data.getProducersOfCategory : null}
          />
        )}
      </Query>
    )
  }
}

ListProducersByRegionContainer.propTypes = {
  category: PropTypes.string.isRequired
}

export default ListProducersByRegionContainer
